<template>
  <v-dialog v-model="viewDialog" class="the-app-dialogs" persistent max-width="1100px">
    <v-card>
      <v-layout row class="no-select not-printable" style="background-color:#09132f">
        <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
          <v-layout align-center>
            <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
            <span class="px-3">{{ $t('View Payroll information') }}</span>
          </v-layout>
        </h3>
        <v-spacer />
        <v-card-actions>
          <v-btn fab icon dark @click="$emit('hidemodal')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-layout>

      <v-card-title class="view-dialog-content grey lighten-3" id="printArea">
        <invoice-header class="only-for-print" />
        <v-layout column>
          <table class="section-title-table only-for-print">
            <tr>
              <th class="section-title-content">{{ $t('Payrolls') }}</th>
            </tr>
          </table>

          <v-layout row wrap class="invoice-content">
            <v-flex xs12 sm12 :class="{ 'px-4': $vuetify.breakpoint.smAndUp }">
              <v-layout row wrap>
                <table class="info-table" style="width: 100%">
                  <tr>
                    <td style="width: 40%" class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ $t('Payroll Code') }}
                      </div>
                      <strong>{{ viewInfo.payroll_code || '-' }}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ $t('Payroll Month') }}
                      </div>
                      <strong>{{ viewInfo.payroll_month || '-' }}</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">{{ $t('Incentive') }}</div>
                      <strong>{{ viewInfo.month_incentive | currency }}</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">{{ $t('Cut') }}</div>
                      <strong>{{ viewInfo.month_cut | currency }}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">{{ $t('Note') }}</div>
                      <strong v-html="lnToBr(viewInfo.data_note) || '-'" />
                    </td>
                  </tr>
                </table>

                <table class="printed-table" cellspacing="0">
                  <thead>
                    <tr class="only-for-print">
                      <td>
                        <div class="header-space">&nbsp;</div>
                      </td>
                    </tr>
                    <tr>
                      <th class="view-table-header" xs2 pa-2>
                        <span style="width:20%; float: left; text-align: center; font-size: 16px">#</span>
                        <span style="width: 80%">{{ $t('Staff') }}</span>
                      </th>
                      <th class="view-table-header" xs2 pa-2>
                        {{ `${$t('Base Salary')} (${systemCurrency})` }}
                      </th>
                      <th class="view-table-header" xs1 pa-2>
                        {{ `${$t('Incentive')} (${systemCurrency})` }}
                      </th>
                      <th class="view-table-header" xs1 pa-2>
                        {{ `${$t('Cut')} (${systemCurrency})` }}
                      </th>
                      <th class="view-table-header" xs2 pa-2>
                        {{ `${$t('Net Salary')} (${systemCurrency})` }}
                      </th>
                      <th class="view-table-header" xs2 pa-2>
                        {{ $t('Note') }}
                      </th>
                      <th class="view-table-header" xs2 pa-2>
                        {{ $t('Signature') }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in rowNumbers" :key="index">
                      <td class="view-table-row">
                        <p
                          class="view-table-content"
                          style="width:20%; float: left; text-align: center; font-size: 16px"
                        >
                          {{ index + 1 }}
                        </p>
                        <p class="view-table-content" style="width: 80%;">
                          {{ viewInfo.user_full_name[index] }}
                        </p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ viewInfo.base_salary[index] | currency }}
                        </p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ viewInfo.incentive[index] | currency }}
                        </p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ viewInfo.cut[index] | currency }}
                        </p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ viewInfo.net_salary[index] | currency }}
                        </p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ viewInfo.note[index] }}
                        </p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content"></p>
                      </td>
                    </tr>
                    <tr style="font-weight: bold">
                      <td class="last-table-row2">
                        <p class="view-table-content">
                          {{ `${$t('Total')} (${systemCurrency})` }}
                        </p>
                      </td>
                      <td class="last-table-row2">
                        <p class="view-table-content">
                          {{ viewInfo.total_base_salary | currency }}
                        </p>
                      </td>
                      <td class="last-table-row2">
                        <p class="view-table-content">
                          {{ viewInfo.total_incentive | currency }}
                        </p>
                      </td>
                      <td class="last-table-row2">
                        <p class="view-table-content">
                          {{ viewInfo.total_cut | currency }}
                        </p>
                      </td>
                      <td class="last-table-row2">
                        <p class="view-table-content">
                          {{ viewInfo.total_net_salary | currency }}
                        </p>
                      </td>
                      <td class="last-table-row2">
                        <p class="view-table-content"></p>
                      </td>
                      <td class="last-table-row2">
                        <p class="view-table-content"></p>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="only-for-print">
                      <td>
                        <div class="footer-space">&nbsp;</div>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </v-layout>
              <invoice-footer
                :showSignatureSection="false"
                :accountantName="''"
                :payerRecipientName="''"
                :payerOrRecipient="''"
                class="only-for-print"
              />
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card-title>
      <v-divider light />

      <v-card-actions class="grey lighten-3 not-printable">
        <v-layout justify-end>
          <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Close') }}</v-btn>
          <v-btn color="primary" @click="printMe()">
            <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">
              print
            </v-icon>
            {{ $t('Print') }}
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'

export default {
  name: 'view-component',

  props: {
    viewDialog: { type: Boolean, required: true }
  },

  components: {
    invoiceHeader: () => import('@/views/_partials/invoiceHeader.vue'),
    invoiceFooter: () => import('@/views/_partials/invoiceFooter.vue')
  },

  data() {
    return {
      systemCurrency: localStorage.systemCurrency,
      rowNumbers: 0,
      viewInfo: {
        payroll_id: 0,
        payroll_code: '',
        payroll_month: '',
        data_note: '',
        month_incentive: '',
        month_cut: '',
        total_incentive: '',
        total_cut: '',
        total_base_salary: '',
        total_net_salary: '',
        payroll_status: '',
        base_salary: [],
        cut: [],
        incentive: [],
        net_salary: [],
        user_full_name: [],
        note: []
      }
    }
  },

  computed: {
    ...mapGetters({
      payrollInfo: 'payrolls/getPayrollInfo'
    })
  },

  watch: {
    viewDialog: {
      immediate: false,
      handler() {
        if (this.viewDialog) {
          this.rowNumbers = this.payrollInfo.details.length
          this.viewInfo.payroll_id = this.payrollInfo.payroll_id
          this.viewInfo.payroll_code = this.payrollInfo.payroll_code
          this.viewInfo.payroll_month = this.payrollInfo.payroll_month
          this.viewInfo.data_note = this.payrollInfo.note
          this.viewInfo.month_incentive = this.payrollInfo.month_incentive
          this.viewInfo.month_cut = this.payrollInfo.month_cut
          this.viewInfo.total_incentive = this.payrollInfo.total_incentive
          this.viewInfo.total_cut = this.payrollInfo.total_cut
          this.viewInfo.total_base_salary = this.payrollInfo.total_base_salary
          this.viewInfo.total_net_salary = this.payrollInfo.total_net_salary
          this.viewInfo.payroll_status = this.payrollInfo.payroll_status

          this.viewInfo.base_salary = []
          this.viewInfo.cut = []
          this.viewInfo.incentive = []
          this.viewInfo.net_salary = []
          this.viewInfo.user_full_name = []
          this.viewInfo.note = []

          this.payrollInfo.details.forEach(detail => {
            this.viewInfo.base_salary.push(detail.base_salary)
            this.viewInfo.cut.push(detail.cut)
            this.viewInfo.incentive.push(detail.incentive)
            this.viewInfo.net_salary.push(detail.net_salary)
            this.viewInfo.user_full_name.push(detail.user_full_name)
            this.viewInfo.note.push(detail.note)
          })
        }
      }
    }
  },

  updated() {
    document.addEventListener('keyup', e => {
      // if the "ESC" button was pressed and this dialog is shown, hide it
      if (e.keyCode === 27 && this.viewDialog) {
        this.$emit('hidemodal')
      }
    })
  },

  methods: {
    lnToBr(str) {
      return helpers.newLineToBreakLine(str)
    },

    printMe() {
      let onlyForPrint = document.querySelectorAll('.only-for-print')
      let notPrintable = document.querySelectorAll('.not-printable')
      let invoiceContent = document.querySelector('.invoice-content')
      let theDialogContent = document.querySelector('.view-dialog-content')
      let infoTable = document.querySelector('.info-table')
      theDialogContent.classList.remove('grey')
      infoTable.classList.add('add-padding-for-info-table')
      invoiceContent.style.marginTop = '90px'
      notPrintable.forEach(element => {
        element.style.display = 'none'
      })
      onlyForPrint.forEach(element => {
        element.style.display = 'block'
      })
      document.querySelector('.printed-table').style.marginTop = '-120px'

      this.$htmlToPaper('printArea', () => {
        infoTable.classList.remove('add-padding-for-info-table')
        theDialogContent.classList.add('grey')
        invoiceContent.style.marginTop = '0px'
        onlyForPrint.forEach(element => {
          element.style.display = 'none'
        })
        notPrintable.forEach(element => {
          element.style.display = 'flex'
        })
        document.querySelector('.printed-table').style.marginTop = '0px'
      })
    }
  }
}
</script>

<style scoped>
.only-for-print {
  display: none;
}
</style>
